import { Component, EventEmitter, Input, Output } from '@angular/core';
import _ from 'lodash';
import { BehaviorSubject } from 'rxjs';

@Component({
   selector: 'samweb-drop-container',
   templateUrl: './drop-container.component.html',
   styleUrls: ['./drop-container.component.scss'],
})
export class DropContainerComponent {
   @Input()
   public zoneId: string;

   @Input()
   public draggedItemKey: any;

   @Input()
   public hasContent = false;

   @Output()
   public dropListDropped = new EventEmitter<any>();

   @Output()
   public dropListDroppedId = new EventEmitter<number>();

   public isDropListEntered$ = new BehaviorSubject<boolean>(false);

   enterZone() {
      if (!_.isNil(this.draggedItemKey)) {
         this.isDropListEntered$.next(true);
      }
   }

   leaveZone() {
      if (!_.isNil(this.draggedItemKey)) {
         this.isDropListEntered$.next(false);
      }
   }

   drop(event) {
      if (!this.isDropListEntered$.getValue()) {
         return;
      }
      this.dropListDropped.emit(event);
      this.dropListDroppedId.emit(this.draggedItemKey);
      this.isDropListEntered$.next(false);
   }
}
